export const SimpleDivider = () => {
  return <div className='my-4 border-b border-gray-200' />;
};
